import z from 'zod';

import { client } from '~shared/api';

import { LockType, PeriodBySectionDto, PeriodLockDto, SectionWithPeriodDtoScheme } from '../dto';

export async function fetchListPeriods(year?: number, month?: number) {
	const params = new URLSearchParams();
	if (year !== undefined) params.append('year', year.toString());
	if (month !== undefined) params.append('month', month.toString());
	const qs = params.toString();
	const data = await client.get(`/period/section${qs ? `?${qs}` : ''}`);
	return z.array(SectionWithPeriodDtoScheme).parse(data);
}

export async function updatePeriods(data: PeriodBySectionDto[]) {
	return client.put('/period', data);
}

export async function updateLocks(data: PeriodLockDto[]) {
	return client.put('/period/locks', data);
}

export async function lockAll(year: number, month: number, type: LockType, locked: boolean) {
	return client.put('/period/locks/all', { year, month, type, locked });
}
